import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin-right: ${props => props.fluid ? 0 : 'auto'};
  min-width: ${props => props.minWidth || '20rem'};
`;

export const Label = styled.p`
  padding: 0;
  margin: 0;
  font-size: 0.9rem;
  font-family: Montserrat;
  font-weight: 500;
  margin-bottom: 0.2rem;
`;

export const InputContainer = styled.div`
  padding: 0;
  margin: 0;
  border: 0.1rem #808080 solid;
  border-radius: 0.3rem;
  overflow: hidden;
`;

export const Input = styled.input`
  padding: 0;
  margin: 0;
  border: 0;
  padding: 0.5rem 1rem;
  width: 100%;
  font-size: 1rem;
  font-family: Montserrat;
`;

const searchResultButtonHeight = '3rem';

export const SearchResultsContainer = styled.div`
  position: absolute;
  background-color: #FFF;
  max-height: calc(5 * ${searchResultButtonHeight});
  left: 0;
  right: 0;
  z-index: 10;
  border: 0.1rem #AAAAAA solid;
  overflow-y: scroll;
`;

export const SearchResultButton = styled.button`
  padding: 0;
  margin: 0;
  height: ${searchResultButtonHeight};
  padding: 1rem;
  border: 0;
  width: 100%;
  text-align: left;
  background-color: transparent;
  font-family: Montserrat;
  font-size: 1rem;

  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const SearchResultPlaceholder = styled.p`
  padding: 0;
  margin: 0;
  height: ${searchResultButtonHeight};
  padding: 1rem;
  border: 0;
  width: 100%;
  text-align: left;
  background-color: transparent;
  font-family: Montserrat;
  font-size: 1rem;
`;

export const SelectedResultContainer = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  width: 100%;
  background-color: #DDD;
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
  justify-content: space-between;
  align-items: center;
`;

export const SelectedResultText = styled.p`
  padding: 0;
  margin: 0;
  font-size: 1rem;
  font-family: Montserrat;
`;

export const SelectedResultAction = styled.button`
  padding: 0;
  margin: 0;
  border: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.2rem;

  &:hover {
    cursor: pointer;
  }
`;